import React from 'react';
import ReactDOM from 'react-dom';
import RouterSetting from './RouterSetting';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from './js/apiProvider';


// 調整成與瀏覽器相同的語言，試試看是否可阻止翻譯? Beck 2023-03-21
const browserLang = navigator.language;
if (browserLang === "zh-TW" || browserLang === "zh-CN") {
    // 如果瀏覽器語言是中文，將網站語言設置為中文版本
    document.documentElement.lang = "zh-TW";
} else {
    // 其他語言，將網站語言設置為英文版本
    document.documentElement.lang = "en";
}

ReactDOM.render(
    <BrowserRouter>
        <ApiProvider>
            <RouterSetting />
        </ApiProvider>
    </BrowserRouter>
    , document.getElementById('root')
); 